define(["exports", "../AsyncCommand", "createjs"], function(exports, AsyncCommand){

	// LoadMediaCommand
	// A command to load files by means of PreloadJS
	// For more information https://github.com/CreateJS/PreloadJS

	// Fields:
	// manifest - ["filePath/file.jpg", {id:"image", src:"filePath/file.jpg"}]
	// or a path to json that contains:
	// { "manifest": ["filePath/file.jpg", {id:"image", src:"filePath/file.jpg"}]}

	// dataStorage - reference to an object extended abstract class of ./assist/AbstractMediaStorage. Extend it to make use of.
	// ratio - a part of the total loading process.

	function LoadMediaCommand(manifest, dataStorage)
	{
		this._manifest = manifest;
		this._dataStorage = dataStorage;

		this.AsyncCommand_constructor();
	}

	var c = LoadMediaCommand;
	createjs.extend(c, AsyncCommand);
	var p = c.prototype;

	p.execute = function()
	{
		var mfs = this.getManifest();

		this._hasError = false;
		this._lastProgress = 0;

		if (!mfs) { this.dispatchComplete(false); return; }

		this._initManifestIdentification();

		if (this._isLoaded()) { this.dispatchComplete(true); return; }

		var queue = new createjs.LoadQueue(true);
		queue.on("error", _errorHandler_, this);
		queue.on("progress", _progressHandler_, this);
		queue.on("fileload", _fileloadHandler_, this);
		queue.on("complete", _completeHandler_, this);
		this._queue = queue;

		createjs.ManifestLoader.MANIFEST_PROGRESS = 0.1;
		queue.loadManifest(mfs);

		this.AsyncCommand_execute.apply(this);


		function _errorHandler_(event)
		{
			// console.log(event, event.data);
			let item = event.data;
			if (item)
			{
				let type = item.type;
				this._handleItemNotLoaded(item);
				if (type === createjs.Types.CSS || type === createjs.Types.MANIFEST || type === createjs.Types.JSON)
					this._hasError = true;
			}
		}

		function _progressHandler_(event)
		{
			this._handleProgress(event.progress);
		}

		function _fileloadHandler_(event)
		{
			var item = event.item;
			this._handleItem(item, event.result);
			// console.log("fileload " + item + " " + item.type);
		}

		function _completeHandler_(/*event*/)
		{
			if (!this._queue)
			{
				this.dispatchComplete(false);
				return;
			}

			if (!this._hasError)
			{
				this._setLoaded();
			}

			this.dispatchComplete(!this._hasError);
		}

	}

	p.getManifest = function()
	{
		if (typeof this._manifest === "string") {
			return {src: this._manifest, type:createjs.Types.MANIFEST};
		}
		else
		{
			return this._manifest;
		}
	}

	p.cancel = function()
	{
		if (this._queue) this._queue.cancel();
		this.AsyncCommand_cancel.apply(this);
	};

	p.removeListeners = function()
	{
		if (this._queue) this._queue.removeAllEventListeners();

		this.AsyncCommand_removeListeners.apply(this);
	}

	p.dispatchComplete = function(b)
	{
		if (b) this._handleProgress(1);
		this.AsyncCommand_dispatchComplete.apply(this, [b]);
	}

	p._handleProgress = function(progress)
	{
		this._lastProgress = progress;
	}

	p._handleItem = function(item, result)
	{
		var type = item.type;
		var re = /[\/\.]+/g;
		switch (type)
		{
			case createjs.Types.IMAGE:
				if (!re.test(item.id))
				{
					this._addImageLoaded(item, result);
				}
				break;
			case createjs.Types.SVG:
				if (!re.test(item.id))
				{
					this._addSVGLoaded(item, result);
				}
				break;
			case createjs.Types.JSON:
				this._addJSON(item.id, result);
				break;
			case createjs.Types.SPRITESHEET:
				this._addSpritesheet(item, result);
				break;
		}
	}

	p._handleItemNotLoaded = function(item)
	{
		var type = item.type;
		switch (type)
		{
			case createjs.Types.IMAGE:
				this._setImageNotLoaded(item);
				break;
			case createjs.Types.SVG:
				this._setSVGNotLoaded(item);
				break;
			case createjs.Types.JSON:
				this._setJSONNotLoaded(item.id);
				break;
			case createjs.Types.SPRITESHEET:
				this._setSpritesheetNotLoaded(item);
				break;
		}
	}

	p._addImageLoaded = function(item, image)
	{
		if (this._dataStorage)
			this._dataStorage.addImageLoaded(item, image);
	}

	p._setImageNotLoaded = function(item)
	{
		if (this._dataStorage)
			this._dataStorage.setImageNotLoaded(item);
	}

	p._addSVGLoaded = function(item, image)
	{
		if (this._dataStorage)
			this._dataStorage.addSVGLoaded(item, image);
	}

	p._setSVGNotLoaded = function(item)
	{
		if (this._dataStorage)
			this._dataStorage.setSVGNotLoaded(item);
	}

	p._addJSON = function(id, result)
	{
		if (this._dataStorage)
			this._dataStorage.addJSON(id, result);
	}

	p._setJSONNotLoaded = function(id)
	{
		if (this._dataStorage)
			this._dataStorage.setJSONNotLoaded(id);
	}

	p._addSpritesheet = function(id, result)
	{
		if (this._dataStorage)
			this._dataStorage.addSpritesheetLoaded(id, result);
	}

	p._setSpritesheetNotLoaded = function(id)
	{
		if (this._dataStorage)
			this._dataStorage.setSpritesheetNotLoaded(id);
	}

	p._initManifestIdentification = function()
	{
		if (this._dataStorage)
			this._identifier = this._dataStorage.getManifestIdentifier(this._manifest);
	}

	p._isLoaded = function()
	{
		if (this._dataStorage)
			return this._dataStorage.isManifestLoaded(this._identifier);
		return false;
	}

	p._setLoaded = function()
	{
		if (this._dataStorage)
			this._dataStorage.setManifestLoaded(this._identifier);
	}


	LoadMediaCommand.getSingleItemManifest = function(id, src, type)
	{
		var t = createjs.RequestUtils.isText(type) && type || createjs.Types.JSON;

		return [{ "id": id, "src": src, "type": t }];
	}


	// createjs CONSTANTS DUPLICATION TO LoadMediaCommand class
	LoadMediaCommand.TEXT = createjs.Types.TEXT;
	LoadMediaCommand.JSON = createjs.Types.JSON;			// default for the getSingleItemManifest method
	LoadMediaCommand.MANIFEST = createjs.Types.MANIFEST;
	LoadMediaCommand.XML = createjs.Types.XML;
	LoadMediaCommand.CSS = createjs.Types.CSS;
	LoadMediaCommand.SVG = createjs.Types.SVG;
	LoadMediaCommand.JAVASCRIPT = createjs.Types.JAVASCRIPT;
	LoadMediaCommand.SPRITESHEET = createjs.Types.SPRITESHEET;

	createjs.promote(c, "AsyncCommand");

	return c;
});



// WEBPACK FOOTER //
// ./js/rrjs/base/commands/load/LoadMediaCommand.js